export default __webpack_public_path__ + "static/media/Asset-21.9b4462f3.png";